/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * ExpandIcon
 */
export default class ExpandIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M21 14a1 1 0 011 1v4a3 3 0 01-3 3h-4a1 1 0 010-2h4a1 1 0 001-1v-4a1 1 0 011-1zM3 14a1 1 0 011 1v4a1 1 0 001 1h4a1 1 0 010 2H5a3 3 0 01-3-3v-4a1 1 0 011-1zM19 2a3 3 0 012.995 2.824L22 5v4a1 1 0 01-1.993.117L20 9V5a1 1 0 00-.883-.993L19 4h-4a1 1 0 01-.117-1.993L15 2h4zM9 2a1 1 0 110 2H5a1 1 0 00-1 1v4a1 1 0 11-2 0V5a3 3 0 013-3h4z" fillRule="nonzero"/></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

